import { render, staticRenderFns } from "./CrudMainHeader.vue?vue&type=template&id=0a00bf7b&"
import script from "./CrudMainHeader.vue?vue&type=script&lang=js&"
export * from "./CrudMainHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports